module.exports = __webpack_public_path__ + "img/images/new-landing/appstore.svg?8668a77d";